'use client';

import type { ReactNode } from 'react';
import GiftIcon from '@/app/assets/imgs/gift-icon.svg';
import { SITE } from '@/app/constants';
import { toast } from './use-toast';

interface TaskCompletionToastOptions {
  title: ReactNode;
  description: ReactNode;
  actionLabel: ReactNode;
  onAction: () => void;
}

/** 任务进入待领取状态时展示，CTA 只负责打开任务中心。 */
export const showTaskCompletionToast = ({
  title,
  description,
  actionLabel,
  onAction,
}: TaskCompletionToastOptions): void => {
  let dismissToast = () => {};
  const result = toast({
    type: 'custom',
    duration: 8000,
    closable: true,
    closeClassName: 'top-4 right-4 size-4 p-0 text-white/60 opacity-100 hover:text-white',
    containerClassName:
      'fixed top-[72px] right-7 z-[100] w-[334px] max-w-[calc(100vw-32px)] rounded-[12px] border-none bg-[#2E2F33] p-4 text-white shadow-none backdrop-blur-none',
    contentClassName: 'block w-full opacity-100',
    message: (
      <div
        className={`flex w-full flex-col items-start gap-3 ${
          SITE === 'china' ? "font-['PingFang_SC']" : 'font-Poppins'
        }`}
      >
        <div className="flex w-full items-center gap-1 pr-5">
          <img alt="" className="size-6 shrink-0" src={GiftIcon.src} />
          <span className="font-semibold text-white/60 text-xs leading-[normal]">{title}</span>
        </div>
        <p className="w-full font-semibold text-white text-xs leading-[normal]">{description}</p>
        <button
          type="button"
          className="flex h-7 shrink-0 items-center justify-center rounded-[8px] bg-gradient-to-l from-[#A28EFF] to-[#5177FF] px-4 py-2 font-semibold text-white text-xs leading-none hover:brightness-110"
          onClick={() => {
            dismissToast();
            onAction();
          }}
        >
          {actionLabel}
        </button>
      </div>
    ),
  });
  dismissToast = result.dismiss;
};
